export default __webpack_public_path__ + "static/media/accountCreateMeritDescriptionThumbnail.b1a990f1.png";